import { defineTokens } from '@chakra-ui/react';

export const borderWidhtsToken = defineTokens({
  borderWidths: {
    thin: { value: '1px' },
    thick: { value: '2px' },
    medium: { value: '1.5px' },
    large: { value: '6px' },
  },
});
